import React, { Component } from "react";
import { connect } from "react-redux";
import { selectFilter } from "../../actions"
import styled from "styled-components";
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CheckBox from "../../../../common/components/UI/Checkbox/";
import { formatAs, DateFnsFormats } from "../../../../common-client2/src/services/ukgDateTime";
import './filterPanel.scss';

const Container = styled.div`
  margin: 20px 10px 15px 10px;
`;

const FilterHeader = styled.div`
  padding: 5px;
  display: flex;
  border-bottom: 1px solid #e6edf5;
  cursor: pointer;
  font: Bold 16px/18px Roboto;
  &:hover {
    color: #0A54A2;
  }
`;

const FiltersContainer = styled.div`
  height: auto;
  max-height: ${props => (props.open ? '10000px' : "0")};
  transition: max-height 0.3s ease-out;
  overflow: hidden;
`;



class FilterSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };
    }



    handleCheckboxChange = (item) => {
        const { handleLoadToCoverOffers } = this.props
        this.props.selectFilter(item)

        let dates = this.findAffectedDates(item);

        handleLoadToCoverOffers(dates);
    }

    findAffectedDates = (item) => {
        const { storeData } = this.props;
        switch (item.parentCategory) {
            case 0: // My shifts, paycodes, available offers
                switch (item.calendarIds[0]) { // can this have a length >1 ?
                    case "0":
                        return storeData.employeeShifts.map(x => formatAs(x.startDateTime, DateFnsFormats.YMD));
                    case "1":
                        return storeData.employeePaycodes.map(x => formatAs(x.startDateTime, DateFnsFormats.YMD));
                    default:
                        let dates = [];
                        let availableTC = storeData.availableShiftsToCover.filter(x => !x.idOfPrivateEmployees.length
                            && item.calendarIds.includes(x.managerSettingId.toString()))
                        let filteredTC = availableTC.map(x => formatAs(x.isPartial ? x.partialFromDate : x.shift.startDateTime, DateFnsFormats.YMD))
                        let availableSS = storeData.availableShiftToSwapOffers.filter(x => !x.idOfPrivateEmployees.length
                            && !x.isSkipValidation
                            && item.calendarIds.includes(x.managerSettingId.toString()))
                        for (const x of availableSS) {
                            for (const shift of x.shifts) {
                                dates.push(formatAs(shift.startDateTime, DateFnsFormats.YMD))
                            }
                        }
                        let availableOS = storeData.availableOpenShifts.filter(x => item.calendarIds.includes(x.toString()))
                        let filteredOS = availableOS.map(x => formatAs(x.startDate, DateFnsFormats.YMD))

                        let availableVTO = storeData.availableVTO.filter(x => x.type !== 1
                            && item.calendarIds.includes(x.managerSettingId.toString()))
                        let filteredVTO = availableVTO.map(x => formatAs(x.timeOffStartDate, DateFnsFormats.YMD))

                        dates.push(...filteredTC)
                        dates.push(...filteredOS)
                        dates.push(...filteredVTO)
                        return dates;
                }
            case 1: // My reqs
                let dates1 = []
                let myTCRequests = storeData.employeeShiftRequests.filter(x => item.calendarIds.includes(x.managerSettingId.toString()))
                let filteredMyTCRequests = myTCRequests.map(x => formatAs(x.isPartial ? x.partialFromDate : x.shift.startDateTime, DateFnsFormats.YMD))
                let myTCOffers = storeData.employeeShiftOffers.filter(x => item.calendarIds.includes(x.managerSettingId.toString()))
                let filteredMyTCOffers = myTCOffers.map(x => formatAs(x.isPartial ? x.partialFromDate : x.shift.startDateTime, DateFnsFormats.YMD))
                let mySSOffers = storeData.employeeMyShiftSwapOffers.filter(x => !x.idOfPrivateEmployees.length && item.calendarIds.includes(x.managerSettingId.toString()))
                for (const x of mySSOffers) {
                    for (const shift of x.shifts) {
                        dates1.push(formatAs(shift.startDateTime, DateFnsFormats.YMD))
                    }
                }
                let myProposals = storeData.myProposals.filter(x => item.calendarIds.includes(x.managerSettingId.toString()))
                for (const x of myProposals) {
                    for (const shift of x.shifts) {
                        dates1.push(formatAs(shift.startDateTime, DateFnsFormats.YMD))
                    }
                }
                let myOSRequests = storeData.myOpenShiftRequests.filter(x => item.calendarIds.includes(x.managerSettingId.toString()))
                let filteredmyOSRequests = myOSRequests.map(x => formatAs(x.startDate, DateFnsFormats.YMD))
                let myVTORequests = storeData.myVTORequests.filter(x => x.voluntaryTimeOffType !== 1 && item.calendarIds.includes(x.managerSettingId.toString()))
                let filteredVTORequests = myVTORequests.map(x => formatAs(x.timeOffStartDate, DateFnsFormats.YMD))

                dates1.push(...filteredMyTCRequests)
                dates1.push(...filteredMyTCOffers)
                dates1.push(...filteredmyOSRequests)
                dates1.push(...filteredVTORequests)
                return dates1;
            case 2: //By status
                let dates2 = [];
                let availableTC2 = storeData.availableShiftsToCover.filter(x => !x.idOfPrivateEmployees.length
                    && item.statusIds.includes(x.status))
                let filteredTC2 = availableTC2.map(x => formatAs(x.isPartial ? x.partialFromDate : x.shift.startDateTime, DateFnsFormats.YMD))
                let availableSS2 = storeData.availableShiftToSwapOffers.filter(x => !x.idOfPrivateEmployees.length
                    && item.statusIds.includes(x.status))
                for (const x of availableSS2) {
                    for (const shift of x.shifts) {
                        dates2.push(formatAs(shift.startDateTime, DateFnsFormats.YMD))
                    }
                }
                let availableOS2 = storeData.availableOpenShifts.filter(x => item.calendarIds.includes(0))
                let filteredOS2 = availableOS2.map(x => formatAs(x.startDate, DateFnsFormats.YMD))

                let availableVTO2 = storeData.availableVTO.filter(x => x.type !== 1
                    && item.statusIds.includes(x.status))
                let filteredVTO2 = availableVTO2.map(x => formatAs(x.timeOffStartDate, DateFnsFormats.YMD))

                let myTCRequests2 = storeData.employeeShiftRequests.filter(x => item.statusIds.includes(x.status))
                let filteredMyTCRequests2 = myTCRequests2.map(x => formatAs(x.isPartial ? x.partialFromDate : x.shift.startDateTime, DateFnsFormats.YMD))
                let myTCOffers2 = filteredMyTCRequests2.filter(x => item.statusIds.includes(x.status))
                let filteredMyTCOffers2 = myTCOffers2.map(x => formatAs(x.isPartial ? x.partialFromDate : x.shift.startDateTime, DateFnsFormats.YMD))
                let mySSOffers2 = storeData.employeeMyShiftSwapOffers.filter(x => !x.idOfPrivateEmployees.length && item.statusIds.includes(x.status))
                for (const x of mySSOffers2) {
                    for (const shift of x.shifts) {
                        dates2.push(formatAs(shift.startDateTime, DateFnsFormats.YMD))
                    }
                }
                let myProposals2 = storeData.myProposals.filter(x => item.statusIds.includes(x.status))
                for (const x of myProposals2) {
                    for (const shift of x.shifts) {
                        dates2.push(formatAs(shift.startDateTime, DateFnsFormats.YMD))
                    }
                }
                let myOSRequests2 = storeData.myOpenShiftRequests.filter(x => item.statusIds.includes(x.status))
                let filteredmyOSRequests2 = myOSRequests2.map(x => formatAs(x.startDate, DateFnsFormats.YMD))
                let myVTORequests2 = storeData.myVTORequests.filter(x => x.voluntaryTimeOffType !== 1 && item.statusIds.includes(x.status))
                let filteredVTORequests2 = myVTORequests2.map(x => formatAs(x.timeOffStartDate, DateFnsFormats.YMD))

                dates2.push(...filteredTC2)
                dates2.push(...filteredOS2)
                dates2.push(...filteredVTO2)
                dates2.push(...filteredMyTCRequests2)
                dates2.push(...filteredMyTCOffers2)
                dates2.push(...filteredmyOSRequests2)
                dates2.push(...filteredVTORequests2)
                return dates2;
            case 3: // Skip Validation Offers
                let dates3 = [];
                let availableSS3 = storeData.availableShiftToSwapOffers.filter(x =>
                    x.isSkipValidation &&
                    !x.idOfPrivateEmployees.length &&
                    item.calendarIds.includes(x.managerSettingId.toString())
                );
                for (const x of availableSS3) {
                    for (const shift of x.shifts) {
                        dates3.push(formatAs(shift.startDateTime, DateFnsFormats.YMD));
                    }
                }
                return dates3;
            default:
                break;
        }
    }

    render() {
        const { section, filtersDefinition, title, myActiveManagerSettings, availableActiveManagerSettings, t } = this.props;
        let filters = filtersDefinition[section].filters;
        const { expanded } = this.state;

        if (section === "myItem") {
            filters = filters.filter(x => x.calendarIds.some(y => availableActiveManagerSettings.includes(parseInt(y))));
        } else if (section === "myRequest") {
            filters = filters.filter(x => x.calendarIds.some(y => myActiveManagerSettings.includes(parseInt(y))));
        }

        return (
            <Container className="filter-section">
                <FilterHeader
                    onClick={() => {
                        this.setState({ expanded: !expanded });
                    }}
                >
                    {t("filterPanel." + title)}
                    <FontAwesomeIcon
                        className={expanded ? 'filter-section-rotation-in' : 'filter-section-rotation-off'}
                        icon={["far", "chevron-up"]}
                    />
                </FilterHeader>
                <FiltersContainer open={expanded} items={filters.length}>
                    {filters.map(item => (
                        <label key={item.id} className="filter-section-checkbox-container">
                            <CheckBox
                                color={item.borderColor}
                                checked={item.checked}
                                onChange={(e) => { this.handleCheckboxChange(item, e) }}
                            />
                            <span style={{ marginLeft: 5 }}>{item.name}</span>
                        </label>
                    ))}
                </FiltersContainer>
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        filtersDefinition: state.filters,
        storeData: state.data,
    };
};

export default connect(mapStateToProps, { selectFilter })(withTranslation('employmentBillboard')(FilterSection));
